<template>
  <div class="overlay" @click="$emit('close')">
    <div class="dialog" @click.stop>
      <h3 class="title">Cerrar plan {{ plan.folio }}</h3>

      <!-- RN-08/09: si falta algo, se enumera TODO antes de dejar capturar.
           La base vuelve a verificarlo al guardar. -->
      <div v-if="!cierre.ok" class="bloqueo">
        <strong>Todavía no se puede cerrar:</strong>
        <ul>
          <li v-for="(m, i) in cierre.faltan" :key="i">{{ m }}</li>
        </ul>
      </div>

      <template v-else>
        <label class="field">
          <span class="field-label">Resultado obtenido</span>
          <textarea
            v-model="f.resultadoObtenido"
            rows="3"
            class="inp"
            placeholder="Qué se logró y cómo se verificó"
          ></textarea>
          <span v-if="errores.resultadoObtenido" class="field-error">
            {{ errores.resultadoObtenido }}
          </span>
        </label>

        <label class="field">
          <span class="field-label">Lecciones aprendidas</span>
          <textarea
            v-model="f.leccionesAprendidas"
            rows="2"
            class="inp"
            placeholder="Opcional"
          ></textarea>
        </label>

        <div class="grid-2">
          <label class="field">
            <span class="field-label">Efectividad</span>
            <select v-model="f.nivelEfectividad" class="inp">
              <option value="efectiva">Efectiva</option>
              <option value="parcial">Parcial</option>
              <option value="no_efectiva">No efectiva</option>
            </select>
            <span v-if="errores.nivelEfectividad" class="field-error">
              {{ errores.nivelEfectividad }}
            </span>
          </label>
          <label class="field">
            <span class="field-label">Calificación (1 a 5)</span>
            <select v-model.number="f.calificacion" class="inp">
              <option :value="null">— Sin calificar —</option>
              <option v-for="n in 5" :key="n" :value="n">{{ n }}</option>
            </select>
            <span v-if="errores.calificacion" class="field-error">
              {{ errores.calificacion }}
            </span>
          </label>
        </div>
      </template>

      <p v-if="error" class="error">{{ error }}</p>

      <div class="acciones">
        <button class="btn cancel" @click="$emit('close')">Cancelar</button>
        <button
          v-if="cierre.ok"
          class="btn confirm"
          :disabled="busy"
          :style="{ background: busy ? '#cbd5e1' : '#16a34a' }"
          @click="cerrar"
        >
          {{ busy ? "Cerrando…" : "Validar y cerrar" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { puedeCerrar } from "../cx.rules";
import { validaCierre } from "../cx.validators";

export default {
  name: "CerrarPlanModal",
  props: {
    plan: { type: Object, required: true },
    busy: { type: Boolean, default: false },
    error: { type: String, default: "" },
  },
  emits: ["confirm", "close"],
  data() {
    return {
      errores: {},
      f: {
        resultadoObtenido: "",
        leccionesAprendidas: "",
        nivelEfectividad: "efectiva",
        calificacion: null,
      },
    };
  },
  computed: {
    cierre() {
      return puedeCerrar(this.plan);
    },
  },
  methods: {
    cerrar() {
      if (this.busy) return;
      const r = validaCierre(this.f);
      this.errores = r.errores;
      if (!r.ok) return;
      this.$emit("confirm", { ...this.f });
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.45);
}
.dialog {
  width: 100%;
  max-width: 480px;
  max-height: 100%;
  overflow-y: auto;
  background: var(--pt-card, #fff);
  color: var(--pt-text, #0f172a);
  border-radius: 16px;
  padding: 20px;
}
.title {
  font-size: 17px;
  font-weight: 700;
  margin: 0 0 12px;
}
.bloqueo {
  background: #fef3c7;
  color: #92400e;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 13px;
}
.bloqueo ul {
  margin: 6px 0 0;
  padding-left: 18px;
}
.field {
  display: block;
  margin-bottom: 12px;
}
.field-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--pt-dim);
  margin-bottom: 4px;
}
.grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.inp {
  width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  border: 1px solid var(--pt-border);
  outline: none;
  background: var(--pt-card);
  color: var(--pt-text);
  box-sizing: border-box;
  font-family: inherit;
  resize: none;
}
.inp:focus {
  border-color: #003ca5;
}
.field-error {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #b91c1c;
}
.error {
  margin: 4px 0 0;
  font-size: 13px;
  color: #b91c1c;
}
.acciones {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 12px;
}
.btn {
  padding: 9px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  border: 0;
  cursor: pointer;
  font-family: inherit;
}
.cancel {
  background: var(--pt-track);
  color: var(--pt-dim);
}
.confirm {
  color: #fff;
}
.confirm:disabled {
  cursor: not-allowed;
}
</style>
